<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="1100"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="observer"
    >
      <v-form>
        <v-card
          v-if="orderId"
          flat
        >
          <v-toolbar flat>
            <v-toolbar-title>処分事業場の編集</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <!-- 処分方法 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="処分方法"
                >
                  <v-select
                    v-model="forms.disposal_method_id"
                    :items="disposalMethods"
                    :error-messages="errors"
                    clearable
                    dense
                    hide-details="auto"
                    label="処分方法"
                    outlined
                    persistent-placeholder
                  ></v-select>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /処分方法 -->
            <!-- 基準重量・処分場処理方法 -->
            <v-row
              v-if="orderType !== 'general' && (this.mode === 'transport_disposal' || this.mode === 'disposal')"
            >
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="基準重量"
                >
                  <v-select
                    v-model="forms.standard_quantity_type"
                    :disabled="forms.already_registered"
                    :error-messages="errors"
                    :items="standardQuantityTypes"
                    clearable
                    dense
                    hide-details="auto"
                    label="基準重量"
                    outlined
                    persistent-placeholder
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col
                cols="12" md="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="処分場処理方法"
                >
                  <div class="field-with-copy">
                    <div class="field-with-copy__control">
                      <v-select
                        v-model="forms.recycle_disposer_disposal_method_id"
                        :disabled="forms.already_registered"
                        :error-messages="errors"
                        :items="recycleDisposerDisposalMethods"
                        clearable
                        dense
                        hide-details="auto"
                        label="処分場処理方法"
                        outlined
                        persistent-placeholder
                      >
                        <template v-slot:item="{ item, on, attrs }">
                          <v-list-item v-on="on" v-bind="attrs">
                            <v-list-item-content>
                              <template>
                                <div class="d-flex align-center flex-wrap py-1" style="gap: 8px;">
                                  <v-chip color="primary" label text-color="white" x-small>処分場処理方法</v-chip>
                                  <span class="font-weight-medium">{{ item.pattern_name || item.text }}</span>
                                </div>
                              </template>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <template v-slot:selection="{ item }">
                          {{ item.pattern_name || item.text }}
                        </template>
                      </v-select>
                    </div>
                    <div class="select-actions">
                      <choose-recycle-disposal-pattern-botton
                          :fixed-condition="recyclePatternDialogCondition"
                          small-button
                          button-caption="選択"
                          only-method
                          @choseRecycleDisposalPatternCallback="choseRecycleDisposalPatternCallback"
                      />
                    </div>
                  </div>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /基準重量・処分場処理方法 -->

            <!-- 再資源化等処理情報  -->
            <v-row
              v-if="orderType !== 'general' && (this.mode === 'transport_disposal' || this.mode === 'disposal')"
            >
              <v-col cols="12">
                <recycle-step-table
                  :headers="headers"
                  :result-list="recycleDisposerDisposalMethodDetailsList"
                  :reference-only="true"
                  :hide-origin-ratio="true"
                />
              </v-col>
            </v-row>
            <!-- /再資源化等処理情報  -->
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              更新
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
    <send-mail-confirmable-dialog
      :order-id="orderId"
      :enable-dialog="enableMailConfirmableDialog"
      @negativeCallback="negativeCallback"
      @positiveCallback="positiveCallback"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SendMailConfirmableDialog from '@/driver/pages/orders/accepts/collection/dialogs/_SendMailConfirmableDialog.vue'
import ChooseRecycleDisposalPatternBotton from '@/driver/components/ChooseRecycleDisposalPatternBotton.vue'

const STANDARD_QUANTITY_TYPES = [
  { value: 'fixed_quantity', text: '確定数量' },
  { value: 'waste_quantity', text: '廃棄物の数量' },
  { value: 'transport_quantity', text: '運搬業者の数量' },
  { value: 'disposal_quantity', text: '処分数量' },
]

export default {
  name: 'EditDisposerLocationDialog',
  components: {
    SendMailConfirmableDialog,
    ChooseRecycleDisposalPatternBotton,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    orderId: {
      type: Number,
      default: () => null,
    },
    manifestId: {
      type: Number,
      default: () => null,
    },
    disposalMethods: {
      type: Array,
      default: () => [],
    },
    orderType: {
      type: String,
      default: 'collection'
    },
  },
  data() {
    return {
      enableMailConfirmableDialog: false,
      forms: {
        disposal_method_id: null,
        standard_quantity_type: null,
        recycle_disposer_disposal_method_id: null,
        item_id: null,
        disposer_id: null,
        disposer_location_code: null,
      },
      recycleDisposerDisposalMethods: [],
      headers: [
        { value: "before_disposal_ratio", text: "処分割合", width: "10%" },
        { value: "disposal_method", text: "処分方法", width: "25%" },
        { value: "after_disposal_ratio", text: "処理後割合", width: "10%" },
        { value: "recycle_disposed_item", text: "処理後物の大分類\r\n処理後物の種類", width: "30%" },
        { value: "final_disposal", text: "最終処分", width: "20%" },
        { value: "actions", text: "", width: "5%", align: "end" },
      ],
      selectedRecycleDisposerDisposalMethodForm: null,
      recycleDisposerDisposalMethodDetailsList: [],
    }
  },
  computed: {
    standardQuantityTypes () {
      return STANDARD_QUANTITY_TYPES
    },
    recyclePatternDialogCondition () {
      return {
        item_id: this.forms.item_id,
        disposer_id: this.forms.disposer_id,
        disposer_location_id: this.forms.disposer_location_id,
        disposer_location_code: this.forms.disposer_location_code,
      }
    },
    ...mapState('DriverTenantConfiguration', {
      mode: 'mode',
    }),
  },
  watch: {
    enableDialog (newVal) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms)
      if (newVal) {
        this.setVariable()
      }
    },
    'forms.recycle_disposer_disposal_method_id': {
      handler (newValue) {
        this.loadRecycleDisposerDisposalMethodDetails(newValue)
      },
      immediate: true,
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverOrderAcceptCollectionDisposerLocation', {
      fetchCollectionReport: 'edit',
      updateCollectionReport: 'update',
    }),
    ...mapActions("DriverOrdersCollectionVerifyDisposerLocation", {
      verifyDisposerLocation: "update",
    }),
    /**
     * 処分場処理方法検索
     */
    ...mapActions('DriverMasterSearchRecycleDisposerDisposalMethod', {
      fetchRecycleDisposerDisposalMethods: 'index',
    }),
    /**
     * 処分場処理方法詳細取得
     */
    ...mapActions('DriverMasterRecycleDisposerDisposalMethod', {
      fetchEdit: 'edit',
    }),
    /**
     * 初期値セット
     */
    setVariable () {
      this.fetchCollectionReport({ order_id: this.orderId, manifest_id: this.manifestId }).then((content) => {
        this.forms = content
        this.refreshRecycleDisposerDisposalMethods()
      })
    },
    /**
     * 処分場処理方法一覧取得
     * 品目・処分事業者・処分事業場で絞り込み
     * @return {Promise<void>}
     */
    async refreshRecycleDisposerDisposalMethods () {
      if (!this.forms.item_id || !this.forms.disposer_id || !this.forms.disposer_location_code) {
        this.recycleDisposerDisposalMethods = []
        this.selectedRecycleDisposerDisposalMethodForm = null
        this.recycleDisposerDisposalMethodDetailsList = []
        return Promise.resolve()
      }
      // 品目・処分業者・処分事業場を条件に処分場処理方法を取得
      return this.fetchRecycleDisposerDisposalMethods({
        item_id: this.forms.item_id,
        disposer_id: this.forms.disposer_id,
        disposer_location_code: this.forms.disposer_location_code,
      }).then((content) => {
        this.recycleDisposerDisposalMethods = content.recycle_disposer_disposal_methods || []
      }).catch(() => {
        this.recycleDisposerDisposalMethods = []
        this.selectedRecycleDisposerDisposalMethodForm = null
        this.recycleDisposerDisposalMethodDetailsList = []
      })
    },
    /**
     * 数値をパーセント表記に整える
     * @param value
     * @return {string}
     */
    toPercent (value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }

      const stringValue = `${value}`
      return stringValue.includes('%') ? stringValue : `${stringValue}%`
    },
    /**
     * 処分場処理方法詳細の表示一覧を生成する
     * @return {Array}
     */
    buildRecycleDisposerDisposalMethodDetails () {
      const details = this.selectedRecycleDisposerDisposalMethodForm?.recycle_disposer_disposal_method_details || []

      return details
        .map((detail) => {
          return {
            before_disposal_ratio: detail.before_disposal_ratio,
            recycle_disposal_method_name: detail.recycle_disposal_method_name,
            after_disposal_method_names: detail.after_disposal_method_names,
            after_disposal_ratio: detail.after_disposal_ratio,
            recycle_disposed_item_parent_name: detail.recycle_disposed_item_parent_name,
            recycle_disposed_item_name: detail.recycle_disposed_item_name,
            after_type_label: detail.after_type_label,
            final_disposal: detail.final_disposal,
          }
        })
    },
    /**
     * 選択された処分場処理方法の詳細を取得し、詳細テーブルへ反映する
     * @param recycleDisposerDisposalMethodId
     * @return {Promise<void>}
     */
    async loadRecycleDisposerDisposalMethodDetails (recycleDisposerDisposalMethodId) {
      if (!recycleDisposerDisposalMethodId) {
        this.selectedRecycleDisposerDisposalMethodForm = null
        this.recycleDisposerDisposalMethodDetailsList = []
        return Promise.resolve()
      }
      return this.fetchEdit({ id: recycleDisposerDisposalMethodId }).then((content) => {
        this.selectedRecycleDisposerDisposalMethodForm = content
        this.recycleDisposerDisposalMethodDetailsList = this.buildRecycleDisposerDisposalMethodDetails()
      }).catch(() => {
        this.selectedRecycleDisposerDisposalMethodForm = null
        this.recycleDisposerDisposalMethodDetailsList = []
      })
    },
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    negativeCallback () {
      this.enableMailConfirmableDialog = false;
    },
    positiveCallback () {
      this.updateManifest()
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validate().then((result) => {
        if(result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      let params = this.buildParams();
      this.verifyDisposerLocation({ order_id: this.orderId, manifest_id: this.manifestId, params: params }).then((content) => {
        if (content.changed) {
          this.enableMailConfirmableDialog = true;
        } else {
          this.updateManifest(params);
        }
      })
    },
    updateManifest () {
      let params = this.buildParams()
      this.updateCollectionReport({ order_id: this.orderId, manifest_id: this.manifestId, params: params }).then(() => {
        this.enableMailConfirmableDialog = false;
        this.$emit('registerCallback')
      })
    },
    /**
     * 処分場処理方法検索モーダルの選択結果を反映する
     * @param payload {{ pattern: { id: number, type: string, pattern_name: string } }}
     */
    choseRecycleDisposalPatternCallback (payload) {
      const pattern = payload?.pattern
      if (!pattern || pattern.type !== 'methods') {
        return
      }

      const selectedId = pattern.id
      if (!this.recycleDisposerDisposalMethods.some(method => method.value === selectedId)) {
        this.recycleDisposerDisposalMethods.push({
          value: selectedId,
          text: pattern.pattern_name,
        })
      }
      this.forms.recycle_disposer_disposal_method_id = selectedId
    },
    buildParams () {
      return {
        disposal_method_id: this.forms.disposal_method_id,
        standard_quantity_type: this.forms.standard_quantity_type,
        recycle_disposer_disposal_method_id: this.forms.recycle_disposer_disposal_method_id,
      }
    },
  }
}
</script>

<style scoped lang="scss">

.field-with-copy {
  display: flex;
  align-items: flex-start;
}

.field-with-copy__control {
  flex: 1;
  min-width: 0;
}

.select-actions {
  margin-left: 8px;
  padding-top: 4px;
}

</style>
